import script from "./userProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./userProfile.vue?vue&type=script&setup=true&lang=js"

import "./userProfile.vue?vue&type=style&index=0&id=fe840d9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe840d9c"]])

export default __exports__